export default __webpack_public_path__ + "static/media/Treg_enrichment_CliniMACS_Plus_workflow_web_1to1.7e734d98.png";